/* eslint-disable no-undef */

import { ENVIRONMENT } from "./common/constants";

const PROD = {
  baseName: "/lco-admin",
  teamIamBaseUrl: "https://digi-api.airtel.in/team-iam",
  teamCommonUrl: "https://digi-api.airtel.in/team-common",
  lcoBasePath: "https://digi-api.airtel.in/",
  BefeBaseUrl: "https://digi-api.airtel.in/guardian-teams/",
  befeEnvPostFix: "",
  ticketServiceBaseUrl: "https://digi-api.airtel.in/ticketing/",
  polygonServiceBaseUrl: "https://digi-api.airtel.in/lcoPoly/",
  dashboardServiceBaseUrl: "https://digi-api.airtel.in/lcoDashBoard/",
  teamsBasePath: "/airtel-team",
  googleAPIKey: "AIzaSyB4Cuct9_CY1RX1V8NFDOgP-4o4tjSQ2Ds",
  paymentURL: "https://www.airtel.in/pay",
  googleAnalyticsEnabled: true,
  EMPLOYEE_GA_MEASUREMENT_ID: "G-41N35CK2CR",
  PARTNER_GA_MEASUREMENT_ID: "G-9J59WYLMQS",
  teamOnboardUrl: "https://digi-api.airtel.in/team-onboard/",
  teamBillingUrl: "https://digi-api.airtel.in/team-billing/",
  teamContractManagementBaseUrl:
    "https://digi-api.airtel.in/team-contract-management",
  vendorBasePath: "/airtel-team/vendor",
  widgetLink: "https://www.airtel.in/omni-serviceability/?",
  teamDeboardUrl: "https://digi-api.airtel.in/team-deboard/",
  oadDashboardUrl: "https://www.airtel.in/distributor-portal"
};

const PRE_PROD = {
  baseName: "/longurl/lco-web-preprod",
  teamIamBaseUrl: "http://10.5.74.75:8081/team-iam-qa2",
  teamCommonUrl: "http://10.5.74.75:8081/team-common-qa2",
  lcoBasePath: "http://10.222.186.16:8087/",
  BefeBaseUrl: "https://kongqa.airtel.com/guardian/",
  befeEnvPostFix: "",
  ticketServiceBaseUrl: "http://10.222.186.16:8087/ticketing-sit/",
  polygonServiceBaseUrl: "http://10.222.186.16:8087/lcoPoly/",
  dashboardServiceBaseUrl: "http://10.222.186.16:8087/lcoDashBoard/",
  googleAPIKey: "AIzaSyB4Cuct9_CY1RX1V8NFDOgP-4o4tjSQ2Ds",
  teamsBasePath: "/longurl/on-boarding-preprod",
  paymentURL: "http://tnd.airtel.com/pay",
  googleAnalyticsEnabled: false,
  EMPLOYEE_GA_MEASUREMENT_ID: "G-41N35CK2CR",
  PARTNER_GA_MEASUREMENT_ID: "G-9J59WYLMQS",
  teamBillingUrl: "http://10.5.74.75:8081/team-billing-qa2/",
  teamOnboardUrl: "http://10.5.74.75:8081/team-onboard-qa2/",
  teamContractManagementBaseUrl:
    "http://10.5.74.75:8081/team-contract-management",
  vendorBasePath: "/longurl/on-boarding/vendor",
  teamDeboardUrl: "http://10.5.74.78:8050/team-deboard/",
  widgetLink: "https://tnd.airtel.com/omni-fwa/?",
  oadDashboardUrl: "https://tnd.airtel.com/distributor-portal"
};

const STAGE = {
  baseName: "/longurl/lco-web",
  teamIamBaseUrl: "http://10.5.74.75:8081/team-iam-qa2",
  teamCommonUrl: "http://10.5.74.75:8081/team-common-qa2",
  lcoBasePath: "http://10.5.74.75:8081/",
  BefeBaseUrl: "https://kongqa.airtel.com/teams/guardian/",
  befeEnvPostFix: "",
  ticketServiceBaseUrl: "http://10.5.74.75:8081/ticketing/",
  polygonServiceBaseUrl: "http://10.5.74.75:8081/lcoPoly/",
  dashboardServiceBaseUrl: "http://10.5.74.75:8081/lcoDashBoard/",
  googleAPIKey: "AIzaSyB4Cuct9_CY1RX1V8NFDOgP-4o4tjSQ2Ds",
  teamsBasePath: "/longurl/on-boarding",
  paymentURL: "http://tnd.airtel.com/pay",
  googleAnalyticsEnabled: false,
  EMPLOYEE_GA_MEASUREMENT_ID: "G-41N35CK2CR",
  PARTNER_GA_MEASUREMENT_ID: "G-9J59WYLMQS",
  teamBillingUrl: "http://10.5.74.75:8081/team-billing-qa2/",
  teamOnboardUrl: "http://10.5.74.75:8081/team-onboard-qa2/",
  teamContractManagementBaseUrl:
    "http://10.5.74.75:8081/team-contract-management",
  vendorBasePath: "/longurl/on-boarding/vendor",
  teamDeboardUrl: "http://10.5.74.75:8081/team-deboard-qa2/",
  widgetLink: "https://tnd.airtel.com/omni-fwa/?",
  oadDashboardUrl: "https://tnd.airtel.com/distributor-portal"
};

const SIT = {
  baseName: "/longurl/lco-web-sit",
  teamIamBaseUrl: "http://10.5.74.75:8081/team-iam-qa2",
  teamCommonUrl: "http://10.5.74.75:8081/team-common-qa2",
  lcoBasePath: "http://10.5.74.75:8081/",
  BefeBaseUrl: "https://kongqa.airtel.com/web/guardian/",
  befeEnvPostFix: "/sit",
  ticketServiceBaseUrl:
    "http://lco-web-ui-service.sit.airl.airtelworld.in/ticketing/",
  polygonServiceBaseUrl: "http://10.5.74.75:8081/lcoPoly/",
  dashboardServiceBaseUrl:
    "http://lco-dashboard-service.sit.airl.airtelworld.in/",
  googleAPIKey: "AIzaSyB4Cuct9_CY1RX1V8NFDOgP-4o4tjSQ2Ds",
  teamsBasePath: "/longurl/on-boarding",
  paymentURL: "http://tnd.airtel.com/pay",
  googleAnalyticsEnabled: false,
  EMPLOYEE_GA_MEASUREMENT_ID: "G-41N35CK2CR",
  PARTNER_GA_MEASUREMENT_ID: "G-9J59WYLMQS",
  teamBillingUrl: "http://10.5.74.75:8081/team-billing-qa2/",
  teamOnboardUrl: "http://10.5.74.75:8081/team-onboard-qa2/",
  vendorBasePath: "/longurl/on-boarding/vendor/login",
  teamDeboardUrl: "http://10.5.74.78:8050/team-deboard/",
  widgetLink: "https://tnd.airtel.com/omni-fwa/?"
  , oadDashboardUrl: "https://tnd.airtel.com/distributor-portal"
};

const QA = {
  baseName: "/longurl/lco-web",
  teamIamBaseUrl: "",
  teamCommonUrl: "",
  lcoBasePath: "",
  BefeBaseUrl: "",
  befeEnvPostFix: "",
  ticketServiceBaseUrl: "",
  polygonServiceBaseUrl: "http://10.5.74.75:8081/lcoPoly/",
  dashboardServiceBaseUrl: "",
  googleAPIKey: "AIzaSyB4Cuct9_CY1RX1V8NFDOgP-4o4tjSQ2Ds",
  paymentURL: "http://tnd.airtel.com/pay",
  googleAnalyticsEnabled: false,
  EMPLOYEE_GA_MEASUREMENT_ID: "G-41N35CK2CR",
  PARTNER_GA_MEASUREMENT_ID: "G-9J59WYLMQS",
  teamBillingUrl: "http://10.5.74.75:8081/team-billing-qa2/",
  teamOnboardUrl: "http://10.5.74.75:8081/team-onboard-qa2/",
  vendorBasePath: "/longurl/on-boarding/vendor",
  teamDeboardUrl: "http://10.5.74.78:8050/team-deboard/",
  widgetLink: "https://tnd.airtel.com/omni-fwa/?",
  oadDashboardUrl: "https://tnd.airtel.com/distributor-portal"
};

const DEV = {
  baseName: "/longurl/lco-web",
  teamIamBaseUrl: "http://10.5.74.75:8081/team-iam-qa2",
  teamCommonUrl: "http://10.5.74.75:8081/team-common-qa2",
  lcoBasePath: "http://10.5.74.75:8081/",
  BefeBaseUrl: "https://kongqa.airtel.com/teams/guardian/",
  befeEnvPostFix: "",
  ticketServiceBaseUrl: "http://10.5.74.75:8081/ticketing/",
  polygonServiceBaseUrl: "http://10.5.74.75:8081/lcoPoly/",
  dashboardServiceBaseUrl: "http://10.5.74.75:8081/lcoDashBoard/",
  googleAPIKey: "AIzaSyB4Cuct9_CY1RX1V8NFDOgP-4o4tjSQ2Ds",
  teamsBasePath: "/longurl/on-boarding",
  paymentURL: "http://tnd.airtel.com/pay",
  googleAnalyticsEnabled: false,
  EMPLOYEE_GA_MEASUREMENT_ID: "G-BSTF2BHCJW",
  PARTNER_GA_MEASUREMENT_ID: "G-BSTF2BHCJW",
  teamBillingUrl: "http://10.5.74.75:8081/team-billing-qa2/",
  teamOnboardUrl: "http://10.5.74.75:8081/team-onboard-qa2/",
  teamContractManagementBaseUrl:
    "http://10.5.74.75:8081/team-contract-management",
  vendorBasePath: "/longurl/on-boarding/vendor",
  teamDeboardUrl: "http://10.5.74.78:8050/team-deboard/",
  widgetLink: "https://tnd.airtel.com/omni-fwa/?",
  oadDashboardUrl: "https://tnd.airtel.com/distributor-portal"
};

class ENV {
  env;
  envName;
  constructor() {
    this.envName = ENVIRONMENT.DEV;
    this.env = DEV;
    if (process.env.REACT_APP_ENV === ENVIRONMENT.PROD) {
      this.env = PROD;
      this.envName = ENVIRONMENT.PROD;
    } else if (process.env.REACT_APP_ENV === ENVIRONMENT.STAGE) {
      this.env = STAGE;
      this.envName = ENVIRONMENT.STAGE;
    } else if (process.env.REACT_APP_ENV === ENVIRONMENT.SIT) {
      this.env = SIT;
      this.envName = ENVIRONMENT.SIT;
    } else if (process.env.REACT_APP_ENV === ENVIRONMENT.QA) {
      this.env = QA;
      this.envName = ENVIRONMENT.QA;
    } else if (process.env.REACT_APP_ENV === ENVIRONMENT.PRE_PROD) {
      this.env = PRE_PROD;
      this.envName = ENVIRONMENT.PRE_PROD;
    }
  }

  getBaseUrl() {
    return this.env.baseUrl;
  }

  getBaseName() {
    return this.env.baseName;
  }

  getLcoBasePath() {
    return this.env.lcoBasePath;
  }

  getEnvironment() {
    return this.envName;
  }

  getTeamIAMUrl() {
    return this.env.teamIamBaseUrl;
  }
  getTeamCommonUrl() {
    return this.env.teamCommonUrl;
  }

  getBefeBaseUrl() {
    return this.env.BefeBaseUrl;
  }

  getTicketServiceBaseUrl() {
    return this.env.ticketServiceBaseUrl;
  }

  getPolygonServiceBaseUrl() {
    return this.env.polygonServiceBaseUrl;
  }

  getGoogleAPIKey() {
    return this.env.googleAPIKey;
  }

  getbefeEnvPostFix() {
    return this.env.befeEnvPostFix;
  }

  getTeamsBasePath() {
    return this.env.teamsBasePath;
  }

  getVendorBasePath() {
    return this.env.vendorBasePath;
  }

  getPaymentPath() {
    return this.env.paymentURL;
  }

  getDashboardServiceUrl() {
    return this.env.dashboardServiceBaseUrl;
  }

  getGoogleAnalyticsEnabled() {
    return this.env.googleAnalyticsEnabled;
  }

  getEmployeeGAMeasurementId() {
    return this.env.EMPLOYEE_GA_MEASUREMENT_ID;
  }

  getPartnerGAMeasurementId() {
    return this.env.PARTNER_GA_MEASUREMENT_ID;
  }

  getTeamOnboardUrl() {
    return this.env.teamOnboardUrl;
  }

  getTeamBillingUrl() {
    return this.env.teamBillingUrl;
  }
  getTeamContractBaseUrl() {
    return this.env.teamContractManagementBaseUrl;
  }
  getDeboardBaseUrl() {
    return this.env.teamDeboardUrl;
  }
  getWidgetLink() {
    return this.env.widgetLink;
  }
  getOadDashboardUrl() {
    return this.env.oadDashboardUrl;
  }
}

const instance = new ENV();
Object.freeze(instance);

export default instance;
